import React from "react";
import { SCMakePaymentContainer } from "../Payment/css";
import { ButtonRounded, Button, Alert } from "@payright/web-components";
import { Field } from "redux-form";
import {
  renderDropDown,
} from "../Common/FormFields";
import { reduxForm, formValueSelector } from "redux-form";
import { connect, useSelector } from "react-redux";
import {
  goBackToDashBoard,
  goBackToMakeLoanPayment,
} from "../../actions/paymentActions";
import * as CONSTANT from "../../util/constants/messages";
import Loader from "../Common/Loader";
import { RootState } from "../../reducers";
import moment from "moment";
import PaymentInput from "./PaymentInput";

const selectedPaymentMethodDetails = defaultPaymentMethod => {
  if (!defaultPaymentMethod) {
    return <span className="self-end mobile-self-start">{CONSTANT.NO_DEFAULT_PAYMENT_TEXT}</span>;
  }

  if (defaultPaymentMethod.payment_method_type !== "Card") {
    return <span className="self-end mobile-self-start">{CONSTANT.DIRECT_DEBIT}</span>;
  }

  return (
    <div className="self-end mobile-self-start">
      {defaultPaymentMethod.cardNumber}{" "}
      {defaultPaymentMethod.cardExpiry !== null && (
        <>
          {" "}
          - <strong> Exp : </strong> {defaultPaymentMethod.cardExpiry}
        </>
      )}
    </div>
  );
};

interface LoanProps {
  ID: any;
  balanceRemaining: any;
  loanName: {name: string, ref: string};
  nextRepaymentDate: any;
  paidLoanAmount: any;
  status: any;
  interest: any;
  principal: any;
  payoutAmount: any;
}

let MakeLoanPayment = props => {
  const {
    defaultPaymentMethod,
    handleChangePaymentMethod,
    error,
    handleSubmit,
    changePaymentMethodSucess,
    showMessages,
    paymentSuccess,
    submittingPayment,
    loanListOptions,
    handleLoanSelect
  } = props;

  const { selectedLoan } = useSelector<RootState, {selectedLoan: LoanProps}>(state => ({
    selectedLoan: state.loans.selectedLoan
  }));

  const renderPaymentInput = () => {
    if (submittingPayment){
      return <Loader text={CONSTANT.SUBMITTING_PAYMENT_TEXT} />
    }

    return (
      <PaymentInput
        paymentAmount = {selectedLoan.payoutAmount}
      />
    )
  }

  const renderPaymentSection = () => {
    if (loanListOptions.length < 1) {
      return (
        <div className="alert-box-msg">
          <Alert
            title=""
            icon={<></>}
            body={CONSTANT.NOTHING_TO_PAY}
            outcome="pending"
          />
        </div>
      )
    }

    if (!selectedLoan){
      return (
        <div className="alert-box-msg">
          <Alert
            title=""
            icon={<></>}
            body={CONSTANT.NO_LOAN_SELECTED}
            outcome="pending"
          />
        </div>
      );
    }
    
    return (<>
      <div className="alerts">
        {showMessages(
          changePaymentMethodSucess,
          error,
          CONSTANT.CHANGED_CARD_SUCCESSFULLY_MESSAGE
        )}
      </div>
      <form onSubmit={handleSubmit}>
        <div className="make-payment-section">
          {renderPaymentInput()}
        </div>

        <Button
          type="submit"
          maxWidth="100%"
          disabled={submittingPayment || !selectedLoan}
        >
          Pay Now
        </Button>
        <div className="footnote">
          <span >Making an extra payment won't change your next scheduled repayment date, which remains <strong>{moment(selectedLoan.nextRepaymentDate).format("DD/MM/YYYY")}</strong></span>
        </div>
      </form>
    </>)
  };
  

  return (
    <SCMakePaymentContainer>
      {paymentSuccess ? (
        <>
          <div className="payment-success-section">
            <div className="success-image"></div>
            <h3 className="page-title">{CONSTANT.PAYMENT_COMPLETED_TEXT}</h3>
            <div className="button-collection">
              <Button handleClick={goBackToDashBoard}>
                {CONSTANT.BACK_TO_DASHBOARD}
              </Button>
              <Button handleClick={goBackToMakeLoanPayment} colour="blue" outline>
                {CONSTANT.MAKE_ANOTHER_PAYMENT}
              </Button>
            </div>
          </div>
        </>
      ) : (
        <>
          <h3 className="page-title">{CONSTANT.MAKE_EXTRA_REPAYMENT_TITLE}</h3>
          <div className="account-details">
            <h5>Payment Method</h5>
            {selectedPaymentMethodDetails(defaultPaymentMethod)}
            <div className="self-end mobile-self-start">
              <ButtonRounded handleClick={() => handleChangePaymentMethod()}>
                Change
              </ButtonRounded>
            </div>
          </div>

          {loanListOptions.length > 0 &&
            <div className="loan-list">
              <h5>Loan Number</h5>
              <div className="self-end mobile-self-start">
                <Field
                  className="loanNumberDropdown"
                  name="loanNumber"
                  options={loanListOptions}
                  component={renderDropDown}
                  onChange={handleLoanSelect}
                />
              </div>
            </div>
          }
          {renderPaymentSection()}
        </>
      )}
    </SCMakePaymentContainer>
  );
};

const selector = formValueSelector('PaymentInputForm');

MakeLoanPayment = reduxForm({
  form: "MakeLoanPayment",
  enableReinitialize: true,
})(MakeLoanPayment);

const mapStateToProps = state => {
  return {
    initialValues: {
      loanNumber: state.loans.selectedLoan ? state.loans.selectedLoan.loanName.name : null,
      loanId: state.loans.selectedLoan ? state.loans.selectedLoan.ID : null,
      paymentType: "once_off_regulated",
      paymentAmount: selector(state, 'paymentAmount'),
    },
    defaultPaymentMethod: state.pageData.defaultPaymentMethod,
    changePaymentMethodSucess: state.loanPayments.changePaymentMethodSucess,
    paymentSuccess: state.loanPayments.paymentSuccess,
    submittingPayment:state.loanPayments.submitting,
    paymentType: "once_off_regulated",
  }
};

export default connect(mapStateToProps)(MakeLoanPayment);
